{
  "enum": {
    "IxmUserauthV1AccessRequestStatus": {
      "APPROVED": "Approved",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1ArtifactStatus": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1ArtifactType": {
      "FONT": "Font",
      "LOGO": "Logo",
      "LOGOMARK": "Logomark",
      "OTHER": "Other",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1BankAccountValidation": {
      "AKOYA": "Akoya",
      "EWS_GIACT": "Ews Giact",
      "FINICITY": "Finicity",
      "FISERV": "Fiserv",
      "MX": "MX",
      "PLAID": "Plaid",
      "UNSPECIFIED": "Unspecified",
      "YODLEE": "Yodlee"
    },
    "IxmUserauthV1BrandingVersionCheckOutcome": {
      "FAILED": "Failed",
      "INCONCLUSIVE": "Inconclusive",
      "PASSED": "Passed",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1BrandingVersionStatus": {
      "APPROVED": "Approved",
      "CANCELED": "Canceled",
      "DRAFT": "Draft",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1DownloadBrandingArtifactRequestBrandingArtifactKey": {
      "LOGO": "Logo",
      "LOGOMARK": "Logomark",
      "MAIN_FONT": "Main Font",
      "MONO_FONT": "Mono Font",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1OrganizationMemberInvitationStatus": {
      "ACCEPTED": "Accepted",
      "ACTIVE": "Active",
      "DECLINED": "Declined",
      "REVOKED": "Revoked",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1OrganizationMemberStatus": {
      "ACTIVE": "Active",
      "DELETED": "Deleted",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1OrganizationStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1ProgramStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1RealmAccessStatus": {
      "ACTIVE": "Active",
      "REMOVED": "Removed",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1RealmStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1RoleStatus": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1TenantStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1Theme": {
      "DARK": "Dark",
      "LIGHT": "Light",
      "SYSTEM": "System",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1UserSessionStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    },
    "IxmUserauthV1UserStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxmUserauthV1AccessRequestQueryServiceAccessRequestListFilterableFields": {
      "accessRequestId": "Access Request",
      "status": "Status"
    },
    "IxmUserauthV1ArtifactQueryServiceArtifactListFilterableFields": {
      "artifactId": "Artifact",
      "data": {
        "spec": {
          "type": "Type"
        }
      },
      "programId": "Program",
      "status": "Status"
    },
    "IxmUserauthV1BrandingVersionQueryServiceBrandingVersionListFilterableFields": {
      "brandingVersionId": "Branding Version",
      "programId": "Program",
      "status": "Status"
    },
    "IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationListFilterableFields": {
      "data": {
        "expiresAt": "Expires At"
      },
      "invitationId": "Invitation",
      "organizationId": "Organization",
      "status": "Status"
    },
    "IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberListFilterableFields": {
      "data": {
        "lastSignInAt": "Last Sign In",
        "user": {
          "additional": {
            "mfaEnabled": "MFA Enabled"
          },
          "keys": {
            "userId": "User"
          }
        }
      },
      "organizationId": "Organization",
      "status": "Status",
      "userId": "User"
    },
    "IxmUserauthV1OrganizationQueryServiceOrganizationListFilterableFields": {
      "organizationId": "Organization",
      "status": "Status"
    },
    "IxmUserauthV1ProgramQueryServiceProgramListFilterableFields": {
      "programCode": "Program Code",
      "programId": "Program",
      "realmId": "Realm",
      "status": "Status"
    },
    "IxmUserauthV1RealmAccessQueryServiceRealmAccessListFilterableFields": {
      "organizationId": "Organization",
      "realmAccessId": "Realm Access",
      "realmId": "Realm",
      "status": "Status",
      "tenantId": "Tenant"
    },
    "IxmUserauthV1RealmQueryServiceRealmListFilterableFields": {
      "realmCode": "Realm Code",
      "realmId": "Realm",
      "status": "Status"
    },
    "IxmUserauthV1RoleQueryServiceRoleListFilterableFields": {
      "organizationId": "Organization",
      "roleId": "Role",
      "status": "Status"
    },
    "IxmUserauthV1TenantQueryServiceTenantListFilterableFields": {
      "realmId": "Realm",
      "status": "Status",
      "tenantId": "Tenant",
      "tenantType": "Tenant Type"
    },
    "IxmUserauthV1UserQueryServiceUserListFilterableFields": {
      "data": {
        "additional": {
          "mfaEnabled": "MFA Enabled"
        },
        "lastSignedInAt": "Last Sign In"
      },
      "status": "Status",
      "userId": "User"
    },
    "IxmUserauthV1UserSessionQueryServiceUserSessionListFilterableFields": {
      "sessionId": "Session",
      "status": "Status",
      "userId": "User"
    }
  },
  "oneOf": {
    "IxmUserauthV1AccessRequestEventType": {
      "approved": "Approved",
      "created": "Created",
      "rejected": "Rejected",
      "updated": "Updated"
    },
    "IxmUserauthV1ArtifactEventType": {
      "archived": "Archived",
      "created": "Created"
    },
    "IxmUserauthV1BrandingVersionEventType": {
      "canceled": "Canceled",
      "checkResult": "Check Result",
      "checksPassed": "Checks Passed",
      "created": "Created",
      "rejected": "Rejected",
      "submitted": "Submitted"
    },
    "IxmUserauthV1FontType": {
      "customFont": "Custom Font",
      "googleFont": "Google Font"
    },
    "IxmUserauthV1JoinOrganizationMethod": {
      "createdOrganization": "Created Organization",
      "invitation": "Invitation"
    },
    "IxmUserauthV1LoginRequestCredentials": {
      "basicAuth": "Basic Auth"
    },
    "IxmUserauthV1OrganizationEventType": {
      "created": "Created",
      "updated": "Updated"
    },
    "IxmUserauthV1OrganizationMemberEventType": {
      "joined": "Joined",
      "organizationUpdated": "Organization Updated",
      "permissionsModified": "Permissions Modified",
      "removed": "Removed",
      "sessionInitiated": "Session Initiated",
      "sessionTerminated": "Session Terminated",
      "setDesignations": "Set Designations",
      "userUpdated": "User Updated"
    },
    "IxmUserauthV1OrganizationMemberInvitationEventType": {
      "accepted": "Accepted",
      "created": "Created",
      "declined": "Declined",
      "organizationUpdated": "Organization Updated",
      "revoked": "Revoked"
    },
    "IxmUserauthV1OrganizationUpdate": {
      "controls": "Controls",
      "profile": "Profile"
    },
    "IxmUserauthV1ProgramEventType": {
      "artifactArchived": "Artifact Archived",
      "brandingUpdateRequested": "Branding Update Requested",
      "brandingVersionApproved": "Branding Version Approved",
      "brandingVersionArchived": "Branding Version Archived",
      "brandingVersionRejected": "Branding Version Rejected",
      "clearingDetailsUpdated": "Clearing Details Updated",
      "controlsUpdated": "Controls Updated",
      "created": "Created",
      "programDetailsUpdated": "Program Details Updated"
    },
    "IxmUserauthV1ProgramRegistrationType": {
      "brokerDealer": "Broker Dealer",
      "investmentAdviser": "Investment Adviser",
      "none": "None"
    },
    "IxmUserauthV1RealmAccessEventType": {
      "removeAccess": "Remove Access",
      "setAccess": "Set Access"
    },
    "IxmUserauthV1RealmEventType": {
      "created": "Created",
      "updated": "Updated"
    },
    "IxmUserauthV1RoleEventType": {
      "archived": "Archived",
      "created": "Created",
      "updated": "Updated"
    },
    "IxmUserauthV1SetArtifact": {
      "artifactId": "Artifact",
      "file": "File"
    },
    "IxmUserauthV1SetFontType": {
      "customFont": "Custom Font",
      "googleFont": "Google Font"
    },
    "IxmUserauthV1SetPasswordRequestMethod": {
      "basicAuth": "Basic Auth",
      "forgotPasswordToken": "Forgot Password Token"
    },
    "IxmUserauthV1SrgbColor": {
      "hex": "Hex",
      "hsla": "Hsla",
      "rgba": "Rgba"
    },
    "IxmUserauthV1TenantEventType": {
      "created": "Created",
      "updated": "Updated"
    },
    "IxmUserauthV1UpdateProgramRequestUpdate": {
      "clearingDetails": "Clearing Details",
      "controls": "Controls",
      "details": "Details"
    },
    "IxmUserauthV1UserEventType": {
      "additonalUpdated": "Additonal Updated",
      "created": "Created",
      "sessionInitiated": "Session Initiated",
      "sessionTerminated": "Session Terminated",
      "setPreferences": "Set Preferences",
      "setProfile": "Set Profile"
    },
    "IxmUserauthV1UserSessionEventType": {
      "initiated": "Initiated",
      "refreshed": "Refreshed"
    },
    "IxmUserauthV1WideGamutColor": {
      "displayP3": "Display P3"
    }
  },
  "searchEnum": {
    "IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationListSearchableFields": {
      "data": {
        "profile": {
          "firstName": "First Name",
          "lastName": "Last Name"
        }
      }
    },
    "IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberListSearchableFields": {
      "data": {
        "user": {
          "keys": {
            "email": "Email"
          },
          "profile": {
            "firstName": "First Name",
            "lastName": "Last Name"
          }
        }
      }
    },
    "IxmUserauthV1ProgramQueryServiceProgramListSearchableFields": {
      "data": {
        "details": {
          "name": "Name"
        }
      }
    },
    "IxmUserauthV1UserQueryServiceUserListSearchableFields": {
      "data": {
        "profile": {
          "firstName": "First Name",
          "lastName": "Last Name"
        }
      },
      "email": "Email"
    }
  },
  "sortEnum": {
    "IxmUserauthV1AccessRequestQueryServiceAccessRequestListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1ArtifactQueryServiceArtifactListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1BrandingVersionQueryServiceBrandingVersionListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1OrganizationMemberInvitationQueryServiceOrganizationMemberInvitationListSortableFields": {
      "data": {
        "expiresAt": "Expires At"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1OrganizationMemberQueryServiceOrganizationMemberListSortableFields": {
      "data": {
        "lastSignInAt": "Last Sign In"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1OrganizationQueryServiceOrganizationListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1ProgramQueryServiceProgramListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1RealmAccessQueryServiceRealmAccessListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1RealmQueryServiceRealmListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1RoleQueryServiceRoleListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1TenantQueryServiceTenantListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1UserQueryServiceUserListSortableFields": {
      "data": {
        "lastSignedInAt": "Last Sign In"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxmUserauthV1UserSessionQueryServiceUserSessionListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}